import React from "react";
import { eur } from "../../utils/formatovanie";

export const CIARKOVANIE_BEZ_POPLATKOV = [7, 5];
export const CIARKOVANIE_CIELOVEJ_SUMY = [4, 4];
export const MAXIMALNY_POCET_POPISOV_OSI = 9;
export const POCET_MESIACOV_V_ROKU = 12;
const POLOMER_BODU_CIELA = 5;
const POLOMER_BODU_PRIVKLADU = 4;
const POLOMER_BODU_UKONCENIA_VKLADOV = 3;

export function cssPremenna(nazov, fallback) {
  if (typeof window === "undefined") {
    return fallback;
  }

  const zdroj =
    document.querySelector("#investicna") ||
    document.body ||
    document.documentElement;

  const hodnota = getComputedStyle(zdroj)
    .getPropertyValue(nazov)
    .trim();

  const hodnotaRoot = getComputedStyle(
    document.documentElement
  )
    .getPropertyValue(nazov)
    .trim();

  return hodnota || hodnotaRoot || fallback;
}

export function cislo(hodnota) {
  const vysledok = Number(hodnota);

  return Number.isFinite(vysledok)
    ? vysledok
    : 0;
}

export function formatujSumu(hodnota) {
  return `${eur(
    Math.round(cislo(hodnota))
  )} €`;
}

export function formatujMesiacOsi(mesiac) {
  const mesiacCislo = Math.max(
    0,
    Math.round(cislo(mesiac))
  );

  if (mesiacCislo === 0) {
    return "Začiatok";
  }

  if (
    mesiacCislo %
      POCET_MESIACOV_V_ROKU ===
    0
  ) {
    return `${
      mesiacCislo /
      POCET_MESIACOV_V_ROKU
    }. rok`;
  }

  const celeRoky = Math.floor(
    mesiacCislo /
      POCET_MESIACOV_V_ROKU
  );

  const zvysneMesiace =
    mesiacCislo %
    POCET_MESIACOV_V_ROKU;

  return celeRoky > 0
    ? `${celeRoky} r. ${zvysneMesiace} mes.`
    : `${zvysneMesiace}. mes.`;
}

export function formatujRokOsi(mesiac) {
  const mesiacCislo = Math.max(
    0,
    Math.round(cislo(mesiac))
  );

  if (mesiacCislo === 0) {
    return "Začiatok";
  }

  return `${
    mesiacCislo /
    POCET_MESIACOV_V_ROKU
  }. r.`;
}

export function vypocitajRealnuHodnotu(
  hodnota,
  inflacia,
  mesiac
) {
  const inflaciaCislo = Math.max(
    0,
    cislo(inflacia)
  );

  if (inflaciaCislo <= 0) {
    return Math.max(0, cislo(hodnota));
  }

  return (
    Math.max(0, cislo(hodnota)) /
    Math.pow(
      1 + inflaciaCislo / 100,
      Math.max(0, cislo(mesiac)) /
        POCET_MESIACOV_V_ROKU
    )
  );
}

function bodySPociatkom(
  priebeh,
  jednorazovyVklad
) {
  const body = Array.isArray(priebeh)
    ? priebeh
    : [];

  const pociatocnaHodnota = Math.max(
    0,
    cislo(jednorazovyVklad)
  );

  return [
    {
      mesiac: 0,
      rok: 0,
      hodnota: pociatocnaHodnota,
      poplatky: 0,
      cistyVklad: pociatocnaHodnota,
      hrubyVklad: pociatocnaHodnota,
      poplatokVMesiaci: 0,
    },
    ...body,
  ];
}

function naBodyGrafu(priebeh) {
  return priebeh.map((bod) => ({
    x: Math.max(
      0,
      cislo(bod?.mesiac)
    ),
    y: Math.max(
      0,
      cislo(bod?.hodnota)
    ),
  }));
}

function najdiDosiahnutieCiela(
  priebeh,
  cielovaSuma
) {
  const ciel = Math.max(
    0,
    cislo(cielovaSuma)
  );

  if (ciel <= 0) {
    return null;
  }

  return (
    priebeh.find(
      (bod) =>
        Math.max(
          0,
          cislo(bod?.hodnota)
        ) >= ciel
    ) || null
  );
}

export function textDosiahnutiaCiela(
  variant
) {
  const ciel = Math.max(
    0,
    cislo(
      variant?.nastavenia?.cielovaSuma
    )
  );

  if (ciel <= 0) {
    return {
      text: "",
      zvyraznenie: "",
    };
  }

  const dosiahnutie =
    variant?.dosiahnutieCiela;

  if (!dosiahnutie) {
    return {
      text:
        "Cieľová suma nebola v zadanom horizonte dosiahnutá.",
      zvyraznenie: "",
    };
  }

  const mesiac = Math.max(
    0,
    Math.round(
      cislo(dosiahnutie?.mesiac)
    )
  );

  const rok = Math.ceil(
    mesiac / POCET_MESIACOV_V_ROKU
  );

  return {
    text:
      "CS bola dosiahnutá",
    zvyraznenie:
      `v ${rok} r. (${mesiac} mes.).`,
  };
}

export function useTemaGrafu() {
  const [temaGrafu, setTemaGrafu] =
    React.useState(() =>
      typeof document === "undefined"
        ? "light"
        : document.documentElement.getAttribute(
            "data-theme"
          ) || "light"
    );

  React.useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    const nastavTemu = () => {
      setTemaGrafu(
        document.documentElement.getAttribute(
          "data-theme"
        ) || "light"
      );
    };

    nastavTemu();

    const observer = new MutationObserver(
      nastavTemu
    );

    observer.observe(
      document.documentElement,
      {
        attributes: true,
        attributeFilter: ["data-theme"],
      }
    );

    return () => observer.disconnect();
  }, []);

  return temaGrafu;
}

export function pripravVyvojGrafu({
  vysledok,
  vysledkyInvesticii,
  porovnanieInvesticii,
  nastaveniaVariantov,
  farbaVariant1,
  farbaVariant2,
  surfaceFarba,
}) {
  const maPorovnanie = Boolean(
    porovnanieInvesticii &&
      vysledkyInvesticii?.variant2
  );

  const varianty = (
    maPorovnanie
      ? [
          {
            key: "variant1",
            label: "Variant 1",
            kratkyLabel: "V1",
            vysledok:
              vysledkyInvesticii
                ?.variant1 ||
              vysledok,
            nastavenia:
              nastaveniaVariantov
                ?.variant1 || {},
            farba: farbaVariant1,
          },
          {
            key: "variant2",
            label: "Variant 2",
            kratkyLabel: "V2",
            vysledok:
              vysledkyInvesticii
                ?.variant2,
            nastavenia:
              nastaveniaVariantov
                ?.variant2 || {},
            farba: farbaVariant2,
          },
        ]
      : [
          {
            key: "variant1",
            label: "Variant 1",
            kratkyLabel: "V1",
            vysledok,
            nastavenia:
              nastaveniaVariantov
                ?.variant1 || {},
            farba: farbaVariant1,
          },
        ]
  ).map((variant) => {
    const priebeh = bodySPociatkom(
      variant.vysledok?.priebeh,
      variant.nastavenia
        ?.jednorazovyVklad
    );

    const priebehBezPoplatkov =
      bodySPociatkom(
        variant.vysledok
          ?.priebehBezPoplatkov,
        variant.nastavenia
          ?.jednorazovyVklad
      );

    return {
      ...variant,
      priebeh,
      priebehBezPoplatkov,
      dosiahnutieCiela:
        najdiDosiahnutieCiela(
          priebeh,
          variant.nastavenia
            ?.cielovaSuma
        ),
    };
  });

  const maximalnyMesiac =
    varianty.reduce(
      (maximum, variant) => {
        const poslednyBod =
          variant.priebeh[
            variant.priebeh.length - 1
          ];

        return Math.max(
          maximum,
          cislo(poslednyBod?.mesiac)
        );
      },
      0
    );

  const cieloveVarianty =
    varianty.filter(
      (variant) =>
        cislo(
          variant.nastavenia
            ?.cielovaSuma
        ) > 0
    );

  const datasets = [];
  const zobrazeneCieloveSumy =
    new Set();

  varianty.forEach((variant) => {
    const inflacia = Math.max(
      0,
      cislo(
        variant.vysledok?.inflacia
      )
    );

    const maPoplatky =
      Math.max(
        0,
        cislo(
          variant.vysledok
            ?.strataNaHodnotePoplatkami
        )
      ) > 0;

    const pocetMesiacovVkladania =
      Math.max(
        0,
        Math.round(
          cislo(
            variant.vysledok
              ?.pocetMesiacovVkladania
          )
        )
      );

    const mesiacPrivkladu =
      variant.nastavenia
        ?.jednorazovyPrivkladZapnuty &&
      cislo(
        variant.nastavenia
          ?.jednorazovyPrivklad
      ) > 0 &&
      pocetMesiacovVkladania > 1
        ? Math.min(
            pocetMesiacovVkladania -
              1,
            Math.max(
              1,
              Math.round(
                cislo(
                  variant.nastavenia
                    ?.jednorazovyPrivkladMesiac
                )
              )
            )
          )
        : 0;

    const mesiacUkonceniaVkladov =
      pocetMesiacovVkladania;

    const mesiacDosiahnutiaCiela =
      Math.max(
        0,
        Math.round(
          cislo(
            variant
              .dosiahnutieCiela
              ?.mesiac
          )
        )
      );

    const udalosti = new Set(
      [
        mesiacPrivkladu,
        variant.vysledok
          ?.pocetDodatocnychMesiacov >
        0
          ? mesiacUkonceniaVkladov
          : 0,
        mesiacDosiahnutiaCiela,
      ].filter(
        (mesiac) => mesiac > 0
      )
    );

    datasets.push({
    label: variant.kratkyLabel,
      plnyNazov:
        `${variant.label} po poplatkoch`,
      data: naBodyGrafu(
        variant.priebeh
      ),
      borderColor: variant.farba,
      backgroundColor: variant.farba,
      borderWidth: 2.4,
      pointRadius: (ctx) => {
        const mesiacBodu = cislo(
          ctx.raw?.x
        );

        if (!udalosti.has(mesiacBodu)) {
          return 0;
        }

        if (
          variant.dosiahnutieCiela &&
          mesiacBodu ===
            mesiacDosiahnutiaCiela
        ) {
          return POLOMER_BODU_CIELA;
        }

        if (
          mesiacBodu === mesiacPrivkladu
        ) {
          return POLOMER_BODU_PRIVKLADU;
        }

        return POLOMER_BODU_UKONCENIA_VKLADOV;
      },
      pointHoverRadius: 5,
      pointBorderWidth: 1.5,
      pointBorderColor: surfaceFarba,
      tension: 0.22,
      typ: "hlavny",
      variantLabel: variant.label,
      kratkyLabel: variant.kratkyLabel,
      inflacia,
      priebeh: variant.priebeh,
      jednorazovyVklad: Math.max(
        0,
        cislo(
          variant.nastavenia
            ?.jednorazovyVklad
        )
      ),
      mesiacPrivkladu,
      jednorazovyPrivklad: Math.max(
        0,
        cislo(
          variant.nastavenia
            ?.jednorazovyPrivklad
        )
      ),
      mesiacUkonceniaVkladov:
        variant.vysledok
          ?.pocetDodatocnychMesiacov >
        0
          ? mesiacUkonceniaVkladov
          : 0,
    });

    if (
      maPoplatky &&
      variant.priebehBezPoplatkov
        .length ===
        variant.priebeh.length
    ) {
      datasets.push({
        label:
          `${variant.kratkyLabel} bez poplatkov`,
        plnyNazov:
          `${variant.label} bez poplatkov`,
        data: naBodyGrafu(
          variant.priebehBezPoplatkov
        ),
        borderColor: variant.farba,
        backgroundColor:
          variant.farba,
        borderWidth: 1.7,
        borderDash:
          CIARKOVANIE_BEZ_POPLATKOV,
        pointRadius: 0,
        pointHoverRadius: 4,
        tension: 0.22,
        typ: "bezPoplatkov",
      });
    }

    const cielovaSuma = Math.max(
      0,
      cislo(
        variant.nastavenia
          ?.cielovaSuma
      )
    );

    if (
      cielovaSuma > 0 &&
      !zobrazeneCieloveSumy.has(
        cielovaSuma
      )
    ) {
      const maSpolocnuCielovuSumu =
        cieloveVarianty.filter(
          (polozka) =>
            cislo(
              polozka.nastavenia
                ?.cielovaSuma
            ) === cielovaSuma
        ).length > 1;

      zobrazeneCieloveSumy.add(
        cielovaSuma
      );

      datasets.unshift({
        label:
          maSpolocnuCielovuSumu
            ? "Cieľová suma"
            : `${variant.kratkyLabel} CS`,
        plnyNazov:
          maSpolocnuCielovuSumu
            ? "Cieľová suma"
            : `${variant.label} CS`,
        data: [
          {
            x: 0,
            y: cielovaSuma,
          },
          {
            x: maximalnyMesiac,
            y: cielovaSuma,
          },
        ],
        borderColor: variant.farba,
        backgroundColor:
          variant.farba,
        borderWidth: 1,
        borderDash:
          CIARKOVANIE_CIELOVEJ_SUMY,
        pointRadius: 0,
        pointHoverRadius: 0,
        tension: 0,
        typ: "cielovaSuma",
      });
    }
  });

  return {
    maPorovnanie,
    maximalnyMesiac,
    maData: maximalnyMesiac > 0,
    cieloveVarianty,
    datasets,
  };
}

export function vytvorObrazokGrafu(
  chart,
  farbaPozadia,
  {
    pdfRezim = false,
  } = {}
) {
  const povodnyCanvas =
    chart?.canvas;

  if (
    !povodnyCanvas ||
    typeof document ===
      "undefined" ||
    povodnyCanvas.width <= 0 ||
    povodnyCanvas.height <= 0
  ) {
    return null;
  }

  const povodnyPdfRezim =
    chart.$investPdfRezim;

  if (pdfRezim) {
    chart.$investPdfRezim =
      true;
  }

  chart.stop();
  chart.update("none");

  try {
    const exportCanvas =
      document.createElement(
        "canvas"
      );

    exportCanvas.width =
      povodnyCanvas.width;

    exportCanvas.height =
      povodnyCanvas.height;

    const kontext =
      exportCanvas.getContext(
        "2d"
      );

    if (!kontext) {
      return null;
    }

    kontext.fillStyle =
      farbaPozadia ||
      "#ffffff";

    kontext.fillRect(
      0,
      0,
      exportCanvas.width,
      exportCanvas.height
    );

    kontext.drawImage(
      povodnyCanvas,
      0,
      0
    );

    return exportCanvas.toDataURL(
      "image/png",
      1
    );
  } finally {
    if (pdfRezim) {
      if (
        typeof povodnyPdfRezim ===
        "undefined"
      ) {
        delete chart
          .$investPdfRezim;
      } else {
        chart.$investPdfRezim =
          povodnyPdfRezim;
      }

      chart.update("none");
    }
  }
}